/**
 * Shared constants for sensor-device lists (PD-13926). Status values mirror
 * the SensorStatus enum (online/offline/error/maintenance) — the device-level
 * status is bubbled up from ingestion / the health cron.
 */
export const SENSOR_DEVICE_STATUS_VALUE_MAPPING = [
	{
		value: 'online',
		label: 'Online',
		color: { bg: '#dcfce7', text: '#166534' },
	},
	{
		value: 'offline',
		label: 'Offline',
		color: { bg: '#fee2e2', text: '#991b1b' },
	},
	{
		value: 'error',
		label: 'Error',
		color: { bg: '#fee2e2', text: '#991b1b' },
	},
	{
		value: 'maintenance',
		label: 'Maintenance',
		color: { bg: '#fef3c7', text: '#92400e' },
	},
];
